import React, { useMemo } from "react";

export default function Avatar(props) {
  const { url, firstName, lastName, fullName } = props;

  const initials = useMemo(() => {

    if ((!fullName && !firstName && !lastName)) {
      return "XY"
    }    

    let fName = firstName
    let lName = lastName

    // if full name is there then taking first and last name from it
    if (fullName) {
      fName = fullName
       const seperatedFullName = fullName.split(" ")
       if (seperatedFullName.length > 1) {
         lName = seperatedFullName?.[seperatedFullName.length -1]
       }
    } 

    let initials = fName?.charAt?.(0) || "";
    initials += (lName ? (lName?.charAt?.(0) || "") : (fName?.charAt?.(1) || ""))
    
    return initials;
  }, [firstName, lastName, fullName]);

  return (
    <div className="bimmatch-avatar">
      {url ? (
        <img
          src={url}
          className="img-fluid"
          alt="profile"
          //   style={url ? {} : { transform: "scale(2)" }}
        />
      ) : (
        <div className="initials">
          <h3>{initials}</h3>
        </div>
      )}
    </div>
  );
}
